import { BOA_KEY, rmUrls, VERSION } from "../../constants/ApiUrls";
import {
  getData,
  postData,
  updateData,
} from "../../networkManager/NetworkManager";
export const getRmTypes = async () => {
  return await getData(BOA_KEY + VERSION + rmUrls.GET_rm_List);
};

export const saveRm = async (payload) => {
  return await postData(BOA_KEY + VERSION + rmUrls.SAVE_rm, payload);
};

export const getGoldRm = async (id) => {
  return await getData(BOA_KEY + VERSION + `${id}/${rmUrls.GET_GOLD_rm_List}`);
};

export const updateRm = async (payload, id) => {
  return await updateData(
    BOA_KEY + VERSION + `${id}/${rmUrls.UPDATE_rm_List}`,
    payload
  );
};
